export default {

    /**
     * Get messages list
     * @param state
     */
    getMessages: state => (discussion_id) => {
        // Return tasks list
        return Object.values(state.messages).filter((m) => m.discussion_id == discussion_id);
    },

    /**
     * Get discussions
     * @param state
     */
    getDiscussions: state => ({parent_type, parent_id}) => {
        // Return tasks list
        return Object.values(state.discussions).filter((d) => (d.parent_type == parent_type && d.parent_id == parent_id));
    },

    /**
     * Get discussion by id
     * @param state
     */
    getDiscussionById: state => (id) => {
        // Return discussion
        return state.discussions[id]
    },

    /**
     * Get attachments
     * @param state
     */
    getAttachments: state => (message_id) => {
        // Return tasks list
        return Object.values(state.attachments).filter((d) => (d.message_id == message_id));
    },

    /**
     * Get discussion type by code
     * @param state
     * @returns {function(*): *}
     */
    getDiscussionType: state => (tp) => {
        return state.discussionTypes[tp] ? state.discussionTypes[tp] : "Unknown";
    }

}
